interface UseTextFieldWithMaxLengthParams {
  maxLength: number;
  onChange: (newValue: string) => void;
}

export const useTextFieldWithMaxLength = ({
  onChange,
  maxLength,
}: UseTextFieldWithMaxLengthParams) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    const newValue = value.slice(0, maxLength);

    onChange(newValue);
  };

  return {
    handleChange,
  };
};
